import {basicContext} from "../../../utils/contextUtils";
import _ from "lodash";

export const entities = [
    {
        name: 'FileList',
        //type: "mongoInternal",
        facets: ['files'],
        fields: [
            'FileCategory',
            {
                path: 'filesNumber',
                type: 'integer'
            },
            {
                path: "noDeleteButtonAccess",
                type: 'boolean'
            },
        ],
    },
    {
        name: 'FileConfiguration',
        type: "mongoInternal",
        fields: [
            'TypeOfLiberalityRecord',
            'FileStatus',
            {path: 'categories', type: 'TypeOfProperty', link: 'MTM', nullable: true},
        ],
    },
    {
        name: 'FileCategory',
        fields: [
            {path: 'code', unique: true},
            {path: 'title', unique: true},
            {path: 'fileConfigurations', type: 'FileConfiguration', link: 'OTM'},
            {
                path: 'necessaryOrUsefulTypesOfLiberalityRecord',
                fieldPath: ['fileConfigurations'],
                f: function() {
                    return this?.fileConfigurations?.filter(obj => ['necessary', 'useful'].includes(obj.fileStatus.id)).map(obj => ` ${obj.typeOfLiberalityRecord.name}`).join(', ')
                }
            },
        ],
        filters: [
            {
                name: 'getNecessaryOrUsefulByFileNatureAndExcludeAlreadyUsed',
                isDefault: false,
                async: true,
                query: async function (context, callback) {
                    const fileNature = _.get(context, "data.fileNature")
                    const category = _.get(context, "data.category")
                    const alreadyUsedIds = _.get(context, "data.alreadyUsedIds") || []

                    if (!fileNature) return callback(null, {_id: null})
                    const isNonLifeInsuranceAndNoCategorySelectedYet = fileNature.id !== 'lifeInsurance' && !category
                    if (isNonLifeInsuranceAndNoCategorySelectedYet) return callback(null, {_id: null})

                    const filesCategories = await global.app.C.FileCategory.find({
                        ...basicContext(context),
                        query: {},
                        //fieldPath: ['id']
                    })

                    const isNonLifeInsuranceAndCategorySelected = fileNature.id !== 'lifeInsurance' && category

                    const necessaryOrUsefulfilesCategories = filesCategories.filter(obj => {
                        const fileConfig = obj.fileConfigurations.find(fileConfig => fileConfig.typeOfLiberalityRecord.id === fileNature.id)
                        if (!['necessary', 'useful'].includes(fileConfig?.fileStatus.id)) return false
                        //we apply category filter only in this case
                        if (isNonLifeInsuranceAndCategorySelected) return fileConfig.categories.some(c => c.id === category)
                        return true
                    })

                    return callback(null, {
                        _id: {
                            $in: necessaryOrUsefulfilesCategories.map(obj => new global.ObjectID(obj.id)),
                            $nin: alreadyUsedIds.map(id => new global.ObjectID(id))
                        },
                    })
                }
            },
            {
                name: 'getNecessaryOrUsefulByFileNatureAndExcludeAlreadyUsedForLiberalityRecord',
                isDefault: false,
                async: true,
                query: async function (context, callback) {
                    const fileNature = _.get(context, "data.fileNature")
                    const alreadyUsedIds = _.get(context, "data.alreadyUsedIds") || []
                    if (!fileNature) return callback(null, {_id: null})

                    const filesCategories = await global.app.C.FileCategory.find({
                        ...basicContext(context),
                        query: {},
                        //fieldPath: ['id']
                    })

                    const necessaryOrUsefulfilesCategories = filesCategories.filter(obj => {
                        const fileConfig = obj.fileConfigurations.find(fileConfig => fileConfig.typeOfLiberalityRecord.id === fileNature.id)
                        if (!['necessary', 'useful'].includes(fileConfig?.fileStatus.id)) return false
                        return true
                    })

                    return callback(null, {
                        _id: {
                            $in: necessaryOrUsefulfilesCategories.map(obj => new global.ObjectID(obj.id)),
                            $nin: alreadyUsedIds.map(id => new global.ObjectID(id))
                        },
                    })
                }
            }
        ]
    }
]
